import { httpsCallable } from "firebase/functions";

import { functionsClient } from "./firebase";
import type { IdentityRequest, IdentityRequestKind } from "../types/identity";

export type CreateIdentityRequestInput = {
  kind: IdentityRequestKind;
  note?: string;
  declaredInstitution?: string;
};

export async function createIdentityRequest(input: CreateIdentityRequestInput) {
  const callable = httpsCallable<CreateIdentityRequestInput, { request: IdentityRequest }>(
    functionsClient,
    "createIdentityRequest"
  );
  return (await callable(input)).data.request;
}

export async function listMyIdentityRequests(limit = 50) {
  const callable = httpsCallable<{ limit: number }, { requests: IdentityRequest[] }>(
    functionsClient,
    "listMyIdentityRequests"
  );
  return (await callable({ limit })).data.requests;
}

export async function cancelIdentityRequest(requestId: string) {
  const callable = httpsCallable<{ requestId: string }, { request: IdentityRequest }>(
    functionsClient,
    "cancelIdentityRequest"
  );
  return (await callable({ requestId })).data.request;
}
